// extracted by mini-css-extract-plugin
export default {"down":"MessagerPage_down__Xi-OT"};